import Vue, {PropType} from "vue";
import {HighlightOption} from "@/enum/highlight_option";
import {stripMarkers} from "@/utils/string";
import {highlightKeywordStemsInHtml} from "@/service/keywordStemDensity";

export default Vue.extend({
    name: 'HighlightWordsMixin',
    props: {
        wordsToHighlight: {
            type: Object as PropType<{[key: string]: string[] }>,
            default: () => ({})
        }
    },
    methods: {
        highlightLanguage: function (): string {
            return (this.$store && this.$store.getters && this.$store.getters.article
                && this.$store.getters.article.language_code) || 'cs';
        },
        highlightWords: function (toHighlight: string): string {
            if (!Object.keys(this.wordsToHighlight).length || !toHighlight) {
                return toHighlight;
            }
            let content = stripMarkers(toHighlight);
            const highlightOptions = Object.values(HighlightOption);
            const language = this.highlightLanguage();
            let i = 0;
            for (const keyword of Object.keys(this.wordsToHighlight)) {
                const marker = highlightOptions[i++ % highlightOptions.length];
                content = highlightKeywordStemsInHtml(content, keyword, marker, language);
            }
            return content;
        }
    }
});
